import { getSangjoQuotationRequestExists } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { useCustomVariation } from "@/hooks/useCustomVariation";
import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import { customEvent, HackleEventName, VStack } from "goi_common";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import RequestQuestionStepByStep, {
  RequestQuestionStepByStepB,
} from "./components/MatchRequest/RequestQuestionUniqueStep/RequestQuestionStepByStep";
import useRouterChangeLoad from "./hooks/useRouterChangeLoad";

export default function MatchRequestContainer() {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const router = useRouter();
  const responseData = useRecoilValue<any>(matchRequestResDataState);

  useRouterChangeLoad();

  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  useEffect(() => {
    if (isLoggedIn) {
      customEvent({
        hackle: { key: HackleEventName["견적 요청서 작성 페이지 방문"] },
      });

      getSangjoQuotationRequestExists().then((res) => {
        if (res.request_exists) {
          onOpenRequestExistModal(res.first_quotation_id);
        } else {
          if (responseData.id && responseData.funeral_sido && responseData.funeral_sigungu) {
            router.push(
              `/match/request-complete?id=${responseData.id}&sido=${responseData.funeral_sido}&sigungu=${responseData.funeral_sigungu}`,
            );
            return;
          }
        }
      });
    }
  }, [isLoggedIn]);

  const variation = useCustomVariation(127);

  return (
    <VStack alignItems="center">
      <VStack id="wrapper" width="100%" maxWidth="480px">
        {variation === "A" && <RequestQuestionStepByStep />}
        {variation === "B" && <RequestQuestionStepByStepB />}
      </VStack>
    </VStack>
  );
}
